module.exports = __webpack_public_path__ + "static/media/logo.8e4b3b45.png";